import Resource from "./../Resource";

export default class ProductAllocation extends Resource {
  list(params = {}) {
    return this._get("product_allocations", params);
  }
}
